import VisibleDocument from '@app/store/documents/VisibleDocument';

export default class FailedDocumentError extends Error {
  failedDocument: VisibleDocument;

  constructor(message: string, failedDocument: VisibleDocument) {
    super(message);
    this.name = 'FailedDocumentError';
    this.failedDocument = failedDocument;
  }
}
